import pendudukApi from '../../services/pendudukApi'

const SET_DATA = "SET_DATA"

const state = {
	data: null,
}

const mutations = {
	[SET_DATA](state, data) {
		state.data = data
	}
}

const actions = {
	async fetchPenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendudukApi.fetchPenduduk(token, data)
	},
	async fetchAnggotaKkPenduduk({ getters }, no_kk) {
		let token = getters.getAuthService.token
		return await pendudukApi.fetchAnggotaKkPenduduk(token, no_kk)
	},
	async searchPenduduk({ getters }, q) {
		let token = getters.getAuthService.token
		return await pendudukApi.searchPenduduk(q, token)
	},
	async storePenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendudukApi.storePenduduk(token, data)
	},
	async updatePenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendudukApi.updatePenduduk(token, data.id, data.form)
	},
	async hapusPenduduk({ getters }, id) {
		let token = getters.getAuthService.token
		return await pendudukApi.hapusPenduduk(token, id)
	},
	async updateProfilePenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendudukApi.updateProfilePenduduk(token, data)
	},
	async fetchRiwayatImportPenduduk({ getters }) {
		let token = getters.getAuthService.token
		return await pendudukApi.fetchRiwayatImportPenduduk(token)
	},
	async sinkronisasiPenduduk({ getters }, id, data) {
		let token = getters.getAuthService.token
		return await pendudukApi.sinkronisasiPenduduk(token, id, data)
	},
	async cekDataImportPenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendudukApi.cekDataImportPenduduk(token, data.data, data.uploadProgress)
	},
	async showSelfieKtp({ getters }, id) {
		let token = getters.getAuthService.token
		return await pendudukApi.showSelfieKtp(token, id)
	},
}

const getters = {

}

export default {
	state,
	mutations,
	actions,
	getters
}